import { capitalize } from '@repo-level/core-front';
import { ButtonCross } from 'components/buttons';
import { ImageComponent } from 'components/Image';
import { useTheme } from 'hooks/theme';
import { forwardRef } from 'react';

import type { SelectButtonProps } from '../../types';
import { ScSelectButton } from './styled';

export const ProfileSelectButton = forwardRef<
  HTMLDivElement,
  SelectButtonProps
>(
  (
    {
      selectedOption,
      handleOpen,
      handleReset,
      placeholder,
      selected,
      error,
      hideErrorMessage,
      disabled,
      defaultValue,
      canReset,
      selectedOptionWithoutIcon,
      active,
      ...scProps
    },
    ref
  ) => {
    const { arrowLeftIcon: Arrow } = useTheme();

    return (
      <ScSelectButton
        ref={ref}
        {...scProps}
        active={!!active}
        canReset={canReset}
        disabled={disabled}
        error={error != null && error !== ''}
        onClick={handleOpen}
        selected={!!selected}
      >
        <div className="border" />
        <div className="content">
          <div
            className={`value ${
              selectedOption?.icon != null && !selectedOptionWithoutIcon
                ? 'with-icon'
                : ''
            }`}
          >
            {!selectedOptionWithoutIcon && selectedOption?.icon != null && (
              <ImageComponent
                alt=""
                height={20}
                src={selectedOption.icon}
                width={20}
              />
            )}
            {(selectedOption || defaultValue) && (
              <div className="name">
                {selectedOption == null
                  ? defaultValue
                  : (selectedOption.nameV ?? selectedOption.name)}
              </div>
            )}
            {selectedOption == null &&
              defaultValue == null &&
              placeholder != null && (
                <span className="placeholder">{capitalize(placeholder)}</span>
              )}
          </div>
          <div className="select-btn-action">
            {selected && canReset ? (
              <ButtonCross gray onClick={handleReset} relative small />
            ) : (
              <Arrow />
            )}
          </div>
        </div>
      </ScSelectButton>
    );
  }
);
